export default {"src":"/_next/static/media/fileverseLogoSad.d8402424.svg","height":750,"width":750};